import image1 from './Images/image1.png'
import image2 from './Images/image2.png'
import image3 from './Images/image3.png'

export const sliderItems=[
    {
        id:1,
        img:image1,
        title:"SUMMER SALE",
        desc:"DON'T COMPROMISE ON STYLE ! GET FLAT 30% OFF FOR NEW ARRIVALS ",
        bg:"f5fafd"
    },
    {
        id:2,
        img:image2,
        title:"POPULAR SALE",
        desc:"DON'T COMPROMISE ON STYLE ! GET FLAT 30% OFF FOR NEW ARRIVALS ",
        bg:"fbf0f4"
    },
    {
        id:3,
        img:image3,
        title:"WINTER SALE",
        desc:"DON'T COMPROMISE ON STYLE ! GET FLAT 30% OFF FOR NEW ARRIVALS ",
        bg:"fcf1ed"
    }
]

export const categories = [
    {
      id: 1,
      img: "https://images.pexels.com/photos/2897524/pexels-photo-2897524.jpeg?auto=compress&cs=tinysrgb&w=600",
      title: "CLASSIC FALL",
      head:'mens fashion',
      cat:"men"
    },
    {
      id: 2,
      img: "https://images.pexels.com/photos/1844132/pexels-photo-1844132.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
      title: "LOUNGEWEAR LOVE",
      head:'women fashion',
      cat:"women"
    },
    {
      id: 3,
      img: "https://images.pexels.com/photos/5480696/pexels-photo-5480696.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      title: "SPRING FASHION",
      head:'rebound dresses',
      cat:"dress"
    },
    {
      id: 4,
      img: "https://images.pexels.com/photos/1957154/pexels-photo-1957154.jpeg?auto=compress&cs=tinysrgb&w=600",
      title: "VINTAGE DENIM",
      head:'street jeans',
      cat:"jeans"
    },
    {
      id: 5,
      img: "https://images.pexels.com/photos/5886041/pexels-photo-5886041.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      title: "SHIRT STYLE",
      head:'summer fashion',
      cat:"tshirt"
    },
    {
      id: 6,
      img: "https://images.pexels.com/photos/1858407/pexels-photo-1858407.jpeg?auto=compress&cs=tinysrgb&w=600",
      title: "FOOTWEAR",
      head:'walk in',
      cat:"shoe"
    },
];

export const popularProducts = [
  {
    id:1,
    img:"https://d3o2e4jr3mxnm3.cloudfront.net/Mens-Jake-Guitar-Vintage-Crusher-Tee_68382_1_lg.png",
  },
  {
    id:2,
    img:"https://d3o2e4jr3mxnm3.cloudfront.net/Mens-Jake-Guitar-Vintage-Crusher-Tee_68382_1_lg.png",
  },
  {
    id:3,
    img:"https://www.prada.com/content/dam/pradanux_products/U/UCS/UCS319/1YOTF010O/UCS319_1YOT_F010O_S_182_SLF.png",
  },
  {
    id:4,
    img:"https://d3o2e4jr3mxnm3.cloudfront.net/Mens-Jake-Guitar-Vintage-Crusher-Tee_68382_1_lg.png",
  },
  {
    id:5,
    img:"https://images.ctfassets.net/5gvckmvm9289/3BlDoZxSSjqAvv1jBJP7TH/65f9a95484117730ace42abf64e89572/Noissue-x-Creatsy-Tote-Bag-Mockup-Bundle-_4_-2.png",
  },
  {
    id:6,
    img:"https://d3o2e4jr3mxnm3.cloudfront.net/Rocket-Vintage-Chill-Cap_66374_1_lg.png",
  },
  {
    id:7,
    img:"https://d3o2e4jr3mxnm3.cloudfront.net/Mens-Jake-Guitar-Vintage-Crusher-Tee_68382_1_lg.png",
  },
  {
    id:8,
    img:"https://www.pngarts.com/files/3/Women-Jacket-PNG-High-Quality-Image.png",
  },
]
